import { render, staticRenderFns } from "./SpeakingTaskConfig.vue?vue&type=template&id=8ae9d71a"
import script from "./SpeakingTaskConfig.vue?vue&type=script&lang=js"
export * from "./SpeakingTaskConfig.vue?vue&type=script&lang=js"
import style0 from "./SpeakingTaskConfig.vue?vue&type=style&index=0&id=8ae9d71a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports